export const EXPIRED_TOKEN = 'Woops, your token has expired. Please login again.'
export const WHOOPS = 'Woops, ha habido algún error.'
export const SUCCESSFUL_UPDATE_RESET = 'Reset actualizado con éxito'
export const SUCCESSFUL_UPDATED_API_KEY = 'API habilitada con éxito'
export const SUCCESSFUL_UPDATED_USER_LIMIT = 'Límite actualizado con éxito'
export const SUCCESSFUL_UPDATED_USER_API_SERVICE_LIMIT = 'Límite de API actualizado con éxito'
export const SUCCESSFUL_SYNCED_AIRTABLE = 'Actualizado con información de Airtable con éxito'
